import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import React from 'react';

import { DailyQuestionAnswer } from 'src/api/FiretrolApiClient';
import { QuestionBox } from './QuestionBox';
interface DailyQuestionsProps {
  jobId: number;
  questions: DailyQuestionAnswer[];
  onQuestionsChange: (q: DailyQuestionAnswer[]) => void;
}

export const DailyQuestions = React.memo(
  ({ questions, onQuestionsChange }: DailyQuestionsProps) => {
    const updateNote = React.useCallback(
      (id: number, note: string) => {
        onQuestionsChange(
          questions.map((v) => {
            if (v.id === id)
              return {
                ...v,
                note,
              };
            return v;
          }),
        );
      },
      [questions, onQuestionsChange],
    );

    const updateValue = React.useCallback(
      (id: number, value: string) => {
        onQuestionsChange(
          questions.map((v) => {
            if (v.id === id)
              return {
                ...v,
                value,
              };
            return v;
          }),
        );
      },
      [questions, onQuestionsChange],
    );

    if (questions.length === 0) {
      return <Text ta="center">No questions to display</Text>;
    }

    return (
      <Stack gap="md">
        {questions.map((q) => (
          <QuestionBox
            key={q.id}
            question={q}
            onValueChange={updateValue}
            onNoteChange={updateNote}
          />
        ))}
      </Stack>
    );
  },
);
